module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-13bef3aa46be439dd83bf7758708cf95.svg";